export const FEATURE_AUTH_ENABLED = process.env.NEXT_PUBLIC_FEATURE_AUTH === 'true';
export const FEATURE_STATS_ENABLED =
  process.env.NEXT_PUBLIC_FEATURE_STATS === 'true' ||
  process.env.NEXT_FEATURE_STATS_ENABLED === 'true';
export const FEATURE_TESTIMONIOS_ENABLED =
  process.env.NEXT_PUBLIC_FEATURE_TESTIMONIOS === 'true' ||
  process.env.NEXT_FEATURE_TESTIMONIOS === 'true';
